import { getWindow, isSsr } from './general';

export const getAuthorizationToken = () => getWindow()?.THDCustomer?.default?.token ?? '';

export const getSvocId = () => getWindow()?.THDCustomer?.default?.svocID;

export const getUserId = () => getWindow()?.THDCustomer?.default?.userID;

export const getCustomerType = () => getWindow()?.THDCustomer?.default?.customerType;

export const isB2BUser = () => getWindow()?.THDCustomer?.default?.isB2BCustomer;

export const isB2CUser = () => getWindow()?.THDCustomer?.default?.isB2CCustomer;

export const getMemberId = () => {
  if (isSsr) return null;

  const token = getAuthorizationToken();
  const svocId = getSvocId();

  if (token && svocId) return svocId;

  return getWindow()?.THDCustomer?.default?.userID;
};
